import { Me } from '@/types/auth';
import { Country } from '@/types/common';
import { PQ_COUNTRY } from '@/constants/common';

function getPQCountry(user: Me): Country {
  return (user && user.pqCountry ? user.pqCountry : PQ_COUNTRY.BEL) as Country;
}

export default getPQCountry;
